import i18n from '../../language/index'
const moduleAnimationList = [
  {
    id: 0,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2249'),
    formData: {
      _key: 'none'
    }
  }, {
    id: 1,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2250'),
    formData: {
      direction: 'default',
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'fadeIn'
    },
    direction: {
      default: 'view_back_top_edit_103',
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true
  }, {
    id: 2,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2253'),
    formData: {
      direction: 'left',
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'moveIn'
    },
    direction: {
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true
  }, {
    id: 3,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2254'),
    formData: {
      direction: 'default',
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'zoomIn'
    },
    direction: {
      default: 'view_back_top_edit_103',
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true
  }, {
    id: 4,
    typeTitle: i18n.t('components_my_animation_module_animation_list_2266'),
    formData: {
      direction: 'left',
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'bounceIn'
    },
    direction: {
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true
  }, {
    id: 5,
    typeTitle: i18n.t('components_my_animation_module_animation_list_2267'),
    formData: {
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      loop: 0,
      _key: 'flash'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    loop: [i18n.t('components_my_animation_module_animation_list_2268'), i18n.t('components_my_animation_module_animation_list_2269'), i18n.t('components_my_animation_module_animation_list_2270'), i18n.t('components_my_animation_module_animation_list_2271'), i18n.t('components_my_animation_module_animation_list_2272'), i18n.t('components_my_animation_module_animation_list_2273'), i18n.t('components_my_animation_module_animation_list_2274'), i18n.t('components_my_animation_module_animation_list_2275'), i18n.t('components_my_animation_module_animation_list_2276'), i18n.t('components_my_animation_module_animation_list_2277'), i18n.t('components_my_animation_module_animation_list_2278')],
    duration: true,
    delay: true,
  }, {
    id: 6,
    typeTitle: i18n.t('components_my_animation_module_animation_list_2279'),
    formData: {
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'rollIn'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true,
  }, {
    id: 7,
    typeTitle: i18n.t('components_my_animation_module_animation_list_2280'),
    formData: {
      direction: 'leftRight',
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      loop: 0,
      _key: 'flip'
    },
    direction: {
      leftRight: i18n.t('components_my_animation_module_animation_list_2281'),
      topBottom: i18n.t('components_my_animation_module_animation_list_2282'),
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    loop: [i18n.t('components_my_animation_module_animation_list_2268'), i18n.t('components_my_animation_module_animation_list_2269'), i18n.t('components_my_animation_module_animation_list_2270'), i18n.t('components_my_animation_module_animation_list_2271'), i18n.t('components_my_animation_module_animation_list_2272'), i18n.t('components_my_animation_module_animation_list_2273'), i18n.t('components_my_animation_module_animation_list_2274'), i18n.t('components_my_animation_module_animation_list_2275'), i18n.t('components_my_animation_module_animation_list_2276'), i18n.t('components_my_animation_module_animation_list_2277'), i18n.t('components_my_animation_module_animation_list_2278')],
    duration: true,
    delay: true
  }, {
    id: 8,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2255'),
    formData: {
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'elasticLarge'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true
  }, {
    id: 9,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2256'),
    formData: {
      duration: 0.6,
      delay: 0,
      trigger: 'single',
      _key: 'elasticSmall'
    },
    trigger: {
      single: i18n.t('widgets_basic_floating_frame_edit_533'),
      many: i18n.t('widgets_basic_floating_frame_edit_534')
    },
    duration: true,
    delay: true
  }
]

export default moduleAnimationList



// WEBPACK FOOTER //
// ./src/components/my_animation/module_animation_list.js